import { render, staticRenderFns } from "./research-pull-out.vue?vue&type=template&id=09cea023&scoped=true"
import script from "./research-pull-out.ts?vue&type=script&lang=ts&external"
export * from "./research-pull-out.ts?vue&type=script&lang=ts&external"
import style0 from "./research-pull-out.scss?vue&type=style&index=0&id=09cea023&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09cea023",
  null
  
)

export default component.exports